import React, { Component } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import { apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';

// const withRouter = WrappedComponent => props => {
// 	const params = useParams();
// 	const  navigate = useNavigate();
// 	// etc... other react-router-dom v6 hooks
  
// 	return (
// 	  <WrappedComponent
// 		{...props}
// 		params={params}
// 		navigate ={navigate}
// 		// etc...
// 	  />
// 	);
//   };

class Edit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);	
	   
		const questionId = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;
		
		this.state = {
            questionId: questionId,
			title:'',
			selectedOption:{ value: 'active', label: 'Active'},
			priority: '',
			selectedvalue:''
		};
		// this.props.getCategoryDetailList(questionId);
		var qs = require('qs');
		var catid = this.state.questionId;

		axios.get(apiUrl+"chatquestions/listdetail?id="+catid).then(res => {
			this.setState({question:res.data.questionlist.question, priority : res.data.questionlist.priority});
			if(res.data.questionlist.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
			this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}
		}); 		
		
		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);

    }

	handleChange = (r,selOption) => {
       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}
 	};
   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
     		
    }


	componentDidMount() {
		document.title = PageTitle('Default Question Edit');
    }

	
        handleFormSubmit = () => {
			if(this.validateForm()){ 
				this.setState({Loading:true});
				const formPayload = this.state;
				var qs = require('qs');
				var status = '';
				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
				}else{
				status = formPayload.selectedvalue;
				}

				var postObject = {
					admin_id : localStorage.getItem("admin_id"),
					question: formPayload.question,
					priority: formPayload.priority,
					status:  status,
					id: formPayload.questionId				
				};

				let formData = new FormData();
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}		       
				axios.post(apiUrl+"chatquestions/edit",formData ).then(res => {
					if(res.data.status === "success"){	
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
								
					 					setTimeout(
											   function() {
												   $('.success_message').html('');
														// this.props.navigate('/chat');
														this.props.history.push('/chatquestionai');
											   }
											   .bind(this),
											   3000
											   );
					}else{
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
						this.setState({Loading:false});
					}
				});
			}
	}

	validateForm() {
		const {question} = this.state;
	
		let errors = {};
		  let formIsValid = true;
	
		  if(!question){
			formIsValid = false;
			$('.errorquestion').html('<span class="errorspan">Please fill the field</span>');
		}else{
			
			$('.errorquestion').html('');
		}
			
		this.setState({
			errors: errors
		});
		return formIsValid;
	}
  render() {

  	  const {selectedOption} = this.state;	


  	
    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="chatquestionai" />  
      <div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>


			<div className="content-wrapper back-btn">
                 
				   <a className="cursor-pointer btn-arrow" href="/chatquestionai">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg>
				</a>
            </div>
			
			<div className="title">
				<h4>Edit Default Question</h4>
			</div>
			 <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Question<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="text" name="question" onChange={this.handleInputChange} className="form-control" value={this.state.question} />
					<div className="errorquestion"></div>
				</div>		
				<div className="form-group">					
					<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
					<Select 
					value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
					options={lang.common.status_option} 
					onChange={this.handleChange.bind(this, 'status')}
					/>
				</div> 	
			</div>
                  
			<div className="form-right">
				<div className="form-group">
					<label>Priority: </label>
					<input type="text" name="priority" onChange={this.handleInputChange} className="form-control" value={this.state.priority}/>
					<div className="errorpriority"></div>
				</div>

               

			</div>	
			</div>		



			<div className="btn-group export">	
				  <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true?
                                        <span>updating</span>:<span>Submit</span>
                                        }
                   </button>
			</div>
			</form>
			</div>				
		</div>	
	</div>
		 	
    </div>
    );
  }
}


export default (withRouter(Edit));